import { useOrganization } from "@api/organization.api";
import { useScope } from "@state/scopeContext.lib";

export function useActiveOrganization() {
    const { organizationId } = useScope();
    const { data: organization } = useOrganization();

    if (!organization) {
        return null;
    }

    if (organization.id !== organizationId) {
        return null;
    }

    return organization;
}
